import React, { Component } from 'react';
import Modal from 'react-modal';
import './Relogin.css';
import { authContext } from '../../../../libs/adal'
import {Button} from "reactstrap";

const customStyles = {
	content: {
		display: 'flex',
		flexDirection: 'column',
		top: '50%',
		left: '50%',
		right: '50%',
		bottom: 'auto',
		marginRight: '-50%',
		transform: 'translate(-50%, -50%)',
		zIndex: "100",
		padding: "50px",
		textAlign: "justify",
		width: "50%",
		boxShadow: "0 14px 28px rgba(0,0,0,0.25), 0 10px 10px rgba(0,0,0,0.22)"
	},
	overlay: {
		zIndex: 100,
		backgroundColor: 'rgba(50, 50, 50, 0.75)'
	}
};

export default class Relogin extends Component {
	constructor(props) {
		super(props);
		this.state = {
			loading: true
		}
	};

	handleCloseModal = () => {
		this.props.closeReloginModal();
	};

	doRelogin = () => {
		authContext.login();
	};

	render() {
		return (
			<Modal
				animation={false}
				isOpen={this.props.reloginModalOpen}
				style={customStyles}
				ariaHideApp={false}
				shouldCloseOnEsc={true}
				shouldCloseOnOverlayClick={true}
				onRequestClose={this.handleCloseModal}
			>
				<div style={{textAlign: "center"}}>
					<h2 className="relogin-headline">Relogin</h2>
				</div>

				<div className="relogin-message">
					<div>Your current user session has timed out because you have not performed any action for more than 8 hours. Please click on Relogin to log in again.</div>
					<div className="login-button-container"><Button id="relogin-button" onClick={this.doRelogin}>Relogin</Button></div>

				</div>

			</Modal>
		)
	}
}